













import { Component, Prop, Vue } from "vue-property-decorator";
import VueEvent from "@/app/core/decorator/VueEvent";

@Component
export default class ResizeKnob extends Vue {
  @Prop({ type: String, required: true })
  private side!: string;

  @Prop({ type: Boolean, default: false })
  private fontSizeChangeBan!: boolean;

  @Prop({ type: Boolean, default: false })
  private deco!: boolean;

  @VueEvent
  private leftDown(event: MouseEvent | TouchEvent, side: string): void {
    this.$emit("leftDown", event, side);
  }
}
